
import Dummy from "components/Dummy";
import P from "components/P";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useRef } from "react";
import leftIcon from "resources/img/puffu/left.png";
import newArrow from "resources/img/puffu/newArrow.svg";
import rightIcon from "resources/img/puffu/right.png";
import categorySound from "resources/music/물방울.mp3";
import { useTouchClick } from "shared/hooks/useTouchClick";
import style from "./DemoHorizontalProductDetail3.module.css";
import DemoHorizontalVendingProductLayout3 from "./DemoHorizontalVendingProductLayout3";




function DemoHorizontalProductDetail3(props) {
    const audioRef = useRef();
    const {
        viewData,
        selectedCategory,
        handleTouchStart,
        handleTouchEnd,
        onCloseClick,
        handleTabChange,
        setCurrentTab,
        currentTab,
        shoppingProcesses
    } = props;

    const {
        handleTouchStart: detailCloseTouchStart,
        handleTouchEnd: detailCloseTouchEnd,
    } = useTouchClick(() => onCloseClick(selectedCategory), 10);

    const prevButtonTouch = useTouchClick(() => handleTabChange('prev'));
    const nextButtonTouch = useTouchClick(() => handleTabChange('next'));


    return (
        <HorizontalFlex flexStart>
            <audio ref={audioRef} src={categorySound} preload="auto" />
            <FlexChild width={"100%"}>
                <VerticalFlex>
                    <FlexChild width={"100%"} >
                        <div
                            style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex" }}
                        >
                            <div style={{ zIndex: 99, gap: "10px", display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', top: '30px', right: "300px", width: '25%' }}>
                                <div
                                    onPointerDown={prevButtonTouch.handleTouchStart}
                                    onPointerUp={prevButtonTouch.handleTouchEnd}
                                    style={{
                                        width: "300px",
                                        height: "53px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        // backgroundColor: "var(--point-color)",
                                        // border: "white",
                                        backgroundColor: "white",
                                        border: "1.5px solid var(--main-color)",
                                        color: "#fff",
                                        cursor: "pointer",
                                        borderRadius: '5px',
                                        padding: "0 10px"
                                    }}
                                    className={style.btn}
                                >

                                    <HorizontalFlex>
                                    <FlexChild width={"8%"} justifyContent={"center"}>
                                            {/* <img src={newArrow3} width={"25px"} style={{transform :"translate(10px,0)"}} /> */}
                                            <img src={leftIcon} width={"10px"} style={{ transform: "translate(10px,0)" }} />

                                        </FlexChild>
                                        <FlexChild width={"73%"} justifyContent={"flex-start"}>
                                            {/* <P font={"Pretendard"} weight={700} size={20} color={"white"}>다음 상품</P> */}
                                            <P font={"Pretendard"} weight={700} size={24} color={"var(--main-color)"}>이전 상품</P>
                                        </FlexChild>
                                        
                                    </HorizontalFlex>
                                    {/* <HorizontalFlex>
                                        <FlexChild width={"40%"}>
                                            <img src={newArrow2} width={"20px"} />
                                        </FlexChild>
                                        <FlexChild> */}
                                    {/* <P font={"Pretendard"} weight={700} size={20} color={"white"}>이전 상품</P> */}
                                    {/* <P font={"Pretendard"} weight={700} size={20} color={"var(--main-color)"}>이전 상품</P> 
                                        </FlexChild>
                                    </HorizontalFlex> */}
                                </div>
                                <div
                                    onPointerDown={nextButtonTouch.handleTouchStart}
                                    onPointerUp={nextButtonTouch.handleTouchEnd}
                                    style={{
                                        width: "300px",
                                        height: "53px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        // backgroundColor: "var(--point-color)",
                                        backgroundColor: "white",
                                        border: "1.5px solid var(--main-color)",
                                        // border: "white",
                                        color: "#fff",
                                        cursor: "pointer",
                                        borderRadius: '5px',
                                        padding: "0 10px"
                                    }}
                                    className={style.btn}
                                >
                                    <HorizontalFlex>
                                        <FlexChild justifyContent={"flex-end"}>
                                            {/* <P font={"Pretendard"} weight={700} size={20} color={"white"}>다음 상품</P> */}
                                            <P font={"Pretendard"} weight={700} size={24} color={"var(--main-color)"}>다음 상품</P>
                                        </FlexChild>
                                        <FlexChild width={"30%"} justifyContent={"center"}>
                                            {/* <img src={newArrow3} width={"25px"} style={{transform :"translate(10px,0)"}} /> */}
                                            <img src={rightIcon} width={"10px"} style={{ transform: "translate(10px,0)" }} />

                                        </FlexChild>
                                    </HorizontalFlex>
                                </div>
                            </div>


                            <div
                                onPointerDown={detailCloseTouchStart}
                                onPointerUp={detailCloseTouchEnd}
                                style={{ position: 'absolute', top: '30px', right: "48px", width: 'max-content', zIndex: '10' }}>
                                <div

                                    className={style.backBtn}
                                    // style={{ width: '241px', height: "53px", backgroundColor: "white", border: "1.5px solid var(--main-color)", borderRadius: "3px" }}
                                    style={{ width: '241px', height: "53px", backgroundColor: "var(--point-color)", border: "1.5px solid var(--main-color)", borderRadius: "3px" }}

                                >
                                    <Center>
                                        <Inline>
                                            <img src={newArrow} color="white" width={"30px"} />
                                            <Dummy width={"15px"} />
                                            {/* <P color={"var(--main-color)"} weight={900} font={"Pretendard"} size={"1.5vw"}>뒤로가기</P> */}
                                            <P color={"white"} weight={700} font={"Pretendard"} size={"1.5vw"}>뒤로가기</P>

                                        </Inline>
                                    </Center>
                                </div>
                            </div>

                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild height={"max-content"}>
                                        <Dummy height={"30px"} />
                                    </FlexChild>
                                    <FlexChild width={"93%"}>
                                        <DemoHorizontalVendingProductLayout3
                                            data={viewData.detailProduct}
                                            currentTab={currentTab}
                                            setCurrentTab={setCurrentTab}
                                            view={viewData.view}
                                            count={viewData.reviewCount}
                                        >
                                        </DemoHorizontalVendingProductLayout3>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </HorizontalFlex>
    );
}

export default DemoHorizontalProductDetail3;